import axios from 'axios'
import { REACT_APP_API } from '../../config'

export default async function getPublications(catalogId, stockId, is0Km) {
    let query = `?catalog_id=${catalogId}`

    if(stockId) {
        query += `&stock_id=${stockId}`
    }

    if (is0Km) query += `&nuevo=${is0Km}`

    try {
        return await axios.get(
            `${REACT_APP_API}/publications/meli${query}`
        )
    } catch (error) {
        if (error?.response?.data?.message)
            error.message = error.response.data.message
        throw error
    }
}
